import DeviceInfo from "@/models/deviceInfo.model";

export interface State {
  devices: DeviceInfo[];
  liveDataConnected: boolean;
  markers: any[];
  settings: any;
  events: any[];
  selectedDevice: string;
  centerLocation: { lat: number, lng: number } | undefined;
}

export const state: State = {
  devices: [],
  liveDataConnected: false,
  markers: [],
  settings: {},
  events: [],
  selectedDevice: "",
  centerLocation: undefined
};
